"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUserAgent = void 0;

var _react = require("react");

// Check if it is first render in SSR
var isSSR = typeof window === 'undefined';

var useUserAgent = function useUserAgent() {
  return (0, _react.useMemo)(function () {
    if (isSSR) {
      return {
        isIOSSafari: false,
        isMacOSSafari: false
      };
    }

    var agent = window.navigator.userAgent.toLowerCase();
    return {
      isIOSSafari: agent.includes('iphone') && agent.includes('safari'),
      isMacOSSafari: !agent.includes('chrome') && agent.includes('safari')
    };
  }, []);
};

exports.useUserAgent = useUserAgent;